import { z } from 'zod';

/**
 * @aiPurpose wire contract for `POST /api/dashboards/agent/v2/ask` — a single
 *   user turn addressed to the Executive AI Analyst (v2). `conversationId` is
 *   omitted on the first turn; the server creates the conversation and returns
 *   its id on the terminal `final` SSE event.
 * @aiInvariant `question` is trimmed at parse-time; an all-whitespace string is
 *   treated as empty and rejects. Unlike v1, there is NO `period` field — v2
 *   derives time ranges through its tools rather than a preset window.
 */
export const AgentV2AskRequestSchema = z
  .object({
    question: z.string().trim().min(1).max(4000),
    conversationId: z.string().uuid().optional(),
  })
  .strict();

export type AgentV2AskRequest = z.infer<typeof AgentV2AskRequestSchema>;
